
export async function CatchWrapperAsync(func, message,error=null)
{ 
    try{
        await func();
    }catch(err){
        message(err.message)
        if(error != null){
            error("errorlog")
        }
    }
}

export function CatchWrapperSync(func, message, error)
{
    try{
        func();
    }catch(err){
        message(err.message)
        error("errorlog")
    }
}


 